function convertTimeToNum (time) {
  if (!time) return 0
  const temp = time.split(':')
  const hour = parseInt(temp[0])
  const ampm = temp[1].substr(2)
  const min = parseInt(temp[1].substr(0, 2))
  return (hour + (ampm === 'pm' && hour < 12 ? 12 : 0)) * 100 + min
}
function timesOverlap (startA, endA, startB, endB) {
  return convertTimeToNum(startA) <= convertTimeToNum(endB) && convertTimeToNum(endA) >= convertTimeToNum(startB)
}

function hasMatchingDays (a, b) {
  for (let c of a) {
    if (b.includes(c)) return true
  }
  return false
}

exports.hasOverlap = function (a, b) {
  if (a.meetingBase.length === 0 || b.meetingBase.length === 0) return false
  for (const { days: aDays, startTime: aStart, endTime: aEnd } of a.meetingBase) {
    const arr = b.meetingBase.filter(({ days: bDays, startTime: bStart, endTime: bEnd }) => {
      if (hasMatchingDays(aDays, bDays) && timesOverlap(aStart, aEnd, bStart, bEnd)) {
        return true
      }
    })
    if (arr.length > 0) return true
  }
  return false
}

exports.timesOverlap = timesOverlap
